




















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Repository } from '@/@types/LibraryComponent';
import Directories from './directories/Directories.vue';
import Branchs from './branchs/Branchs.vue';
import Commits from './commits/Commits.vue';
import Trees from './trees/Trees.vue';
import PullRequests from './pullRequests/PullRequests.vue';
import RepositoryDetailBreadcrumb from '@/components/git/repositoryDetail/RepositoryDetailBreadcrumb.vue';
import RepositoryDetailHeader from '@/components/git/repositoryDetail/RepositoryDetailHeader.vue';
import BranchSelectBox from '@/components/git/repositoryDetail/BranchSelectBox.vue';
import { vxm } from '@/store';
import { FindFileContentQueryDto, FindFilesQueryDto } from '@/@types/theoryGit/files';
import { DefaultBranchName, DeleteBranchDto, FindBranchesDetail } from '@/@types/theoryGit/branches';
import { GetLogsQueryDto } from '@/@types/theoryGit/logs';
import { Route } from 'vue-router';

@Component({
  components: {
    Directories,
    Branchs,
    Commits,
    Trees,
    PullRequests,
    RepositoryDetailBreadcrumb,
    RepositoryDetailHeader,
    BranchSelectBox,
  },
})
export default class RepositoryDetailBase extends Vue {
  private repositoryInfoId: number = 0;
  private repository: Repository = require('@/repository/mock/dummyData/git/repository.json')
    .repository;
  private selectMenu: number = 0;
  private readMeData: string = '';
  private filesCount: number = 0;
  private branchesCount: number = 0;
  private commitLogsCount: number = 0;
  private branches: FindBranchesDetail[] = [];

  private async created() {
    await this.initRepositoryInfo();
    this.repositoryInfoId = parseInt(this.$route.params.id, 10);
    await this.fetchAllRepositoryData(DefaultBranchName.main);
  }

  private async changeBranch(branchName: string) {
    await this.fetchAllRepositoryData(branchName);
  }

  private async fetchAllRepositoryData(branchName: string) {
    await Promise.all([
      this.fetchRepositoryDetail(),
      this.fetchBranchs(),
      this.fetchFiles(branchName),
      this.fetchReadMeContent(branchName),
      this.fetchCommitLogs(branchName),
    ]);
    const readMeData = await this.getFileContent();
    if (typeof readMeData === 'string') {
      this.readMeData = readMeData;
    }
    this.branches.splice(0);
    this.branches.push(...this.getBranches);
    this.filesCount = this.files.length;
    this.branchesCount = this.branches.length;
    this.commitLogsCount = this.commitLogs.length;
  }

  private async fetchRepositoryDetail() {
    await vxm.theoryGit.repositoryInfoStore.fetchOneRepository({
      repositoryInfoId: this.repositoryInfoId,
      projectId: this.projectId,
    });
  }

  private async fetchBranchs() {
    await vxm.theoryGit.branchesStore.fetchBranches({
      repositoryInfoId: this.repositoryInfoId,
      projectId: this.projectId,
    });
  }

  private async fetchFiles(ref: string) {
    const findFilesQuery: FindFilesQueryDto = {
      ref: ref,
      'project-id': this.projectId,
    };
    await vxm.theoryGit.filesStore.fetchFiles({
      repositoryInfoId: this.repositoryInfoId,
      query: findFilesQuery,
    });
  }

  private async fetchReadMeContent(ref: string) {
    const findFileContentQuery: FindFileContentQueryDto = {
      ref: ref,
      'obj-path': 'README.md',
      'project-id': this.projectId,
    };
    await vxm.theoryGit.filesStore.fetchReadMeContent({
      repositoryInfoId: this.repositoryInfoId,
      query: findFileContentQuery,
    });
  }

  /**選択されているブランチのコミットログを取得 */
  private async fetchCommitLogs(ref: string) {
    const query: GetLogsQueryDto = {
      ref: ref,
      'project-id': this.projectId,
    };
    await vxm.theoryGit.logsStore.fetchCommitLogs({
      repositoryInfoId: this.repositoryInfoId,
      query: query,
    });
  }

  private changeSelectMenu(selectMenu: number) {
    this.selectMenu = selectMenu;
  }

  private async deleteBranch(branchName: string) {
    const deleteBranchDto: DeleteBranchDto = {
      repositoryInfoId: this.repositoryInfoId,
      projectId: this.projectId,
      branchName: branchName,
    };
    await vxm.theoryGit.branchesStore.deleteBranch(deleteBranchDto);
    await this.fetchBranchs();
    this.branches.splice(0);
    this.branches.push(...this.getBranches);
    this.branchesCount = this.branches.length;
  }

  /**README.mdの中身を文字列に変換する */
  private async getFileContent() {
    const blob = this.convertToBlob();
    if (blob) {
      const content = await this.readBlob(blob);
      return content;
    }
  }

  private convertToBlob() {
    const uint8Array = Uint8Array.of(...this.readMeContent);
    return new Blob([uint8Array], { type: 'multipart/mixed' });
  }

  private async readBlob(blob: Blob) {
    const fr = new FileReader();
    const promise = new Promise<string | ArrayBuffer | null>((resolve, reject) => {
      fr.onload = () => {
        console.log(fr.result);
        return resolve(fr.result);
      }
      fr.onerror = () => {
        console.error(fr.error);
        return reject(fr.error);
      }
    });
    fr.readAsText(blob);
    return await promise;
  }

  /**リポジトリstoreの情報を初期化 */
  private async initRepositoryInfo() {
    await Promise.all([
      vxm.theoryGit.repositoryInfoStore.initState(),
      vxm.theoryGit.branchesStore.initState(),
      vxm.theoryGit.filesStore.initState(),
      vxm.theoryGit.logsStore.initState(),
      vxm.theoryGit.tagsStore.initState(),
    ]);
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId ?? 0;
  }

  private get repositoryInfoName() {
    return vxm.theoryGit.repositoryInfoStore.getRepositoryInfo?.results.repositoryName ?? '';
  }

  /**現在選択されているリポジトリのブランチ一覧 */
  private get getBranches() {
    return vxm.theoryGit.branchesStore.getBranches?.results ?? [];
  }

  /**現在選択されているブランチのフォルダ・ファイルの一覧 */
  private get files() {
    return vxm.theoryGit.filesStore.getFiles?.results ?? [];
  }

　/**現在選択されているブランチ */
  private get currentBranch() {
    return vxm.theoryGit.branchesStore.getCurrentBranch;
  }

  /**現在選択されているブランチのコミットログ一覧 */
  private get commitLogs() {
    return vxm.theoryGit.logsStore.getCommitLogs?.results ?? [];
  }

  /**現在選択されているブランチのREADME.md */
  private get readMeContent() {
    return vxm.theoryGit.filesStore.getReadMeContent?.results[0].content ?? [];
  }

  @Watch('$route')
  private onRouteChanged(to: Route, from: Route) {
    this.repositoryInfoId = parseInt(to.params.id, 10);
    this.initRepositoryInfo();
    this.fetchAllRepositoryData(DefaultBranchName.main);
  }
}
